import request from '../httpClient';

export const getBotChannel = () => request.get('/channels/bot');

export const getChannels = (
  kind: string,
  limit: number = 20,
  offset?: number
) =>
  request.get(
    `/channels?type=${kind}&_limit=${limit}` +
      (offset ? `&_offset=${offset}` : '')
  );

export const filterChannels = (
  // tslint:disable-next-line: no-any
  params: any,
  kind: string,
  limit: number = 20,
  offset?: number
) =>
  request.get('/channels/search', {
    type: kind,
    _limit: limit,
    _offset: offset,
    ...params
  });

export const getSingleChannel = (id: number) =>
  request.get(`/channels/${id}?_format=full`);

export const fetchChannelMessages = (
  id: number,
  limit: number = 20,
  from?: number
) =>
  request.get(
    `/channels/${id}/messages?_limit=${limit}` + (from ? `&_from=${from}` : '')
  );

export enum MessageType {
  INTERNAL = 'internal',
  EXTERNAL = 'external'
}

export const sendTextMessage = (
  channelId: string | number,
  message: string,
  cid: string,
  messageType: string = 'internal'
) =>
  request.post('/bot/chat', {
    recipient: {channelId},
    messagingType: String(messageType),
    message: {
      text: message,
      cid
    }
  });

export const createChannel = (userIds: number[], unique?: boolean) =>
  request.post('channels', {userIds, distinct: unique});



// WEBPACK FOOTER //
// ./src/services/api/chatApi.ts